module.exports = __webpack_public_path__ + "static/img/jp9.56b056b9.png";